import { useAuth } from "@/utils/auth";
import { useMemo, useState } from "react";

import { useDiaryByIdQuery } from "../../diaries/api";

const useIsMyDiary = (diaryId: string) => {
	const { data: diary, isFetched } = useDiaryByIdQuery(diaryId);

	const [isMyDiary, setIsMyDiary] = useState<boolean | undefined>(undefined);

	const auth = useAuth();

	const checkIfIsMyDiary = () => {
		return auth?.id === diary?.patient_id;
	};

	// biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
	useMemo(() => {
		const myDiary = checkIfIsMyDiary();

		setIsMyDiary(myDiary);
	}, [auth.id, diaryId, isFetched]);

	return { isMyDiary, checkIfIsMyDiary };
};

export default useIsMyDiary;
